(() => {
  function moveHeadlineAboveBubbles() {
    // Finde alle H2 im Facet-Bereich
    const filterWrap = document.querySelector('.facets-wrapper.page-width');
    if (!filterWrap) return;
    const headlines = filterWrap.querySelectorAll('h2');
    if (!headlines.length) return;
    // Suche die erste Headline, die NICHT "Filtern und sortieren" enthält
    let headline = null;
    for (const h of headlines) {
      const txt = h.textContent.trim().toLowerCase();
      if (
        txt &&
        !txt.includes('filtern und sortieren') &&
        !txt.includes('filter') &&
        !txt.includes('sortieren')
      ) {
        headline = h;
        break;
      }
    }
    const bubblesContainer = document.querySelector('.js-bubbles-container');
    if (!headline || !bubblesContainer) return;
    if (headline.classList.contains('gb-moved')) return;
    // Überschrift nach oben verschieben
    bubblesContainer.parentElement.insertBefore(headline, bubblesContainer);
    headline.classList.add('gb-moved');
  }

  function removeCollectionSlider() {
    const nav = document.querySelector('.collection_slider_section_container');
    if (nav && !nav.classList.contains('gb-removed')) {
      nav.classList.add('gb-removed');
      nav.style.display = 'none';
    }
  }

  function upgradeBubbles() {
    const bubblesContainer = document.querySelector('.js-bubbles-container');
    if (!bubblesContainer || bubblesContainer.classList.contains('gb-bubbles-upgraded')) return;

    bubblesContainer.classList.remove('swiper');
    const wrapper = bubblesContainer.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.classList.remove('swiper-wrapper');
      wrapper.style.display = 'flex';
      wrapper.style.flexWrap = 'wrap';
      wrapper.style.gap = '18px';
      wrapper.style.justifyContent = 'center';
      wrapper.style.alignItems = 'center';
      wrapper.style.overflow = 'visible';
      wrapper.querySelectorAll('.bubble').forEach(bubble => {
        bubble.classList.remove('swiper-slide');
        bubble.classList.add('gb-bubble-big');
      });
    }
    bubblesContainer.classList.add('gb-bubbles-upgraded');
  }

  function runAll() {
    removeCollectionSlider();
    moveHeadlineAboveBubbles();
    upgradeBubbles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Shopify AJAX-Navigation Beobachtung (nur einmal)
  let applied = false;
  const observer = new MutationObserver(() => {
    if (!applied) {
      runAll();
      if (document.querySelector('.gb-bubbles-upgraded') && document.querySelector('.gb-moved')) {
        applied = true;
        observer.disconnect();
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 5000);
})();